import { IShapeDrawableObject, instanceOfIShapeDrawableObject } from "./IShapeDrawableObject";

export interface ITriangleObject extends IShapeDrawableObject {}

export function instanceOfITriangleObject(instance: any): instance is ITriangleObject {
  return instanceOfIShapeDrawableObject<ITriangleObject>(instance, "triangle");
}
